const useFetch = () => {
    const firstCoin = localStorage.getItem("FirstCoin") ?? "BTC";
    const baseCoin = localStorage.getItem("BaseCoin") ?? "USDT";
    const RunningPair = localStorage.getItem("RunningPair") ?? "BTCUSDT";
    const isLogin = localStorage.getItem("BasketAuthorizationData") ?? false;
    return [firstCoin, baseCoin, RunningPair , isLogin];
};

export default useFetch;
